<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="로그내역">
            <vs-row class="mb-3" vs-type="flex" vs-align="center">
                <vs-input class="w-2/5" icon="search" placeholder="작성자 or 로그내용 or 날짜 입력후 엔터(Enter)" v-model="search" @keyup.enter="history()" />
                <vs-button class="ml-1" @click="history('init')">초기화</vs-button>
            </vs-row>
            <div class="tb_box">
                <table id="list" style="width:100%;min-width:1400px;" class="border-collapse calendar">
                    <colgroup>
                        <col width="10%" />
                        <col width="10%" />
                        <col width="*" />
                        <col width="10%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">코드</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">작성자</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">LOG</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">날짜</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list" :key="index">
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.LOG_SEQ }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ item.USERNAME }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-left">{{ item.LOG_TEXT }}</td>
                            <td class="p-2 border border-solid d-theme-border-grey-light text-center">{{ $moment(item.INSERT_DATETIME).format('YYYY-MM-DD HH:mm:ss') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
            <vs-pagination :total="total_page" v-model="page" @input="history('p')" :max="7"></vs-pagination>
        </vx-card>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import moment from 'moment';
export default {
    data() {
        return {
            page: 1,
            total_page: 0,
            list: [],
            width: window.innerWidth,
            search: '',
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        init(type) {
            this.history(type);
        },
        async history(type) {
            if (type != 'p') {
                this.page = 1;
            }
            if (type == 'init') {
                this.search = '';
            }
            console.log('page:' + this.page);
            const params = {
                page: this.page,
                search: this.search,
            };
            const { data } = await axiosClass.get('/api/management/logHistory', params, true);
            console.log(data);
            this.list = data.list;
            this.total_page = data.pageCount;
            setTimeout(() => {
                this.$vs.loading.close('#list > .con-vs-loading');
            }, 100);
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.init();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style></style>
